import Header from "components/Header/index";
import React, { FC, StrictMode } from "react";

import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import { BrowserRouter as Router } from "react-router-dom";
import { theme } from "configs/theme";
import { ToastContainer } from "react-toastify";

import { store } from "store/store";
import { ThemeProvider } from "react-bootstrap";
import { Provider } from "react-redux";
import { useTranslation } from "react-i18next";
import AppRouter from "./routes/AppRouter";
import "./assets/styles/style.scss";
import "react-toastify/dist/ReactToastify.css";

declare global {
  interface Window {
    initMap: (mapId: string) => google.maps.Map;
  }
}

function initMap(mapId): any {
  return new google.maps.Map(document.getElementById(mapId) as HTMLElement, {
    center: { lat: -34.397, lng: 150.644 },
    zoom: 8,
  });
}

window.initMap = initMap;

const App: FC = () => {
  const { i18n } = useTranslation();
  return (
    <DndProvider backend={HTML5Backend}>
      <ThemeProvider dir={i18n.dir()} theme={theme}>
        <StrictMode>
          <Provider store={store}>
            <Router>
              <div className="App">
                <Header />
                <AppRouter />
                <ToastContainer />
              </div>
            </Router>
          </Provider>
        </StrictMode>
      </ThemeProvider>
    </DndProvider>
  );
};

export default App;
